import { render, staticRenderFns } from "./surface_post_words_edit.vue?vue&type=template&id=33f0957d&scoped=true&"
import script from "./surface_post_words_edit.vue?vue&type=script&lang=js&"
export * from "./surface_post_words_edit.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_words_edit.vue?vue&type=style&index=0&id=33f0957d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0957d",
  null
  
)

export default component.exports